import { useContext } from 'react';
import { SelectFigurantContext, SelectFigurantContextData } from './context';
import { Select } from './types';

type SelectFigurantWithHelpers = SelectFigurantContextData & {
  updateSelectState: ({ state }: { state: Select }) => void;
  updateSelectFigurant: ({
    search,
    selected,
    type,
  }: {
    search?: string;
    selected?: any;
    type: string;
  }) => void;
};

export const useSelectFigurantData = (): SelectFigurantWithHelpers => {
  const context = useContext(SelectFigurantContext);

  if (!context) {
    throw new Error('useSelectFigurantData must be used within a SelectFigurantProvider');
  }

  const updateSelectFigurant = ({
    search = '',
    selected = [],
    type,
  }: {
    search?: string;
    selected?: any;
    type: string;
  }) => {
    const { select, setSelect } = context;

    const step = type === 'search-figurant' || type === 'selected-figurant' ? 1 : 2;

    const payload: any = {
      ...select,
      searchFigurant: type === 'search-figurant' ? search : select.searchFigurant,
      selectedFigurant: type === 'selected-figurant' ? selected : select.selectedFigurant,
      searchFiscal: type === 'search-fiscal' ? search : select.searchFiscal,
      selectedFiscal: type === 'selected-fiscal' ? selected : select.selectedFiscal,
      step,
    };

    setSelect(payload);
  };

  const updateSelectState = ({ state }: { state: Select }) => {
    const { setSelect } = context;

    setSelect(state);
  };

  return { ...context, updateSelectFigurant, updateSelectState };
};
